/** @format */

import {
  PartnerProgramFields,
  PartnerProgramFieldsValues,
} from "../program/partner-program-fields.model";
import { Vacancy } from "../vacancy/vacancy.model";
import { Collaborator } from "./collaborator.model";
import { Goal } from "./goals.model";
import { Partner } from "./partner.model";
import { Resource } from "./resource.model";

/** Основная модель проекта и связанные классы */

export class PartnerProgramInfo {
  id!: number;
  /** Имя из list/detail API; optional для совместимости со старым сервером. */
  name?: string;
  programLinkId!: number;
  programId!: number;
  isSubmitted!: boolean;
  canSubmit!: boolean;
  programFields!: PartnerProgramFields[];
  programFieldValues!: PartnerProgramFieldsValues[];
}

export interface TeamPolicy {
  isFrozen: boolean;
  programLinkId: number | null;
  requiresProgramContext: boolean;
  programLinks: { id: number; programId: number; isSubmitted: boolean; isCompetitive: boolean }[];
}

export class Project {
  teamPolicy?: TeamPolicy;
  id!: number;
  name!: string;
  description!: string;
  targetAudience!: string;
  implementationDeadline!: string;
  trl!: string;
  actuality!: string;
  problem!: string;
  region!: string;
  shortDescription!: string;
  achievements!: { id: number; title: string; status: string }[];
  partners!: Partner[];
  resources!: Resource[];
  goals!: Goal[];
  industry!: number;
  presentationAddress!: string;
  imageAddress!: string;
  numberOfCollaborators!: number;
  viewsCount!: number;
  cover!: null | string;
  coverImageAddress!: string | null;
  /** Канонический признак из detail API; сокращённые списки его не возвращают. */
  isDefaultCover?: boolean;
  collaborators!: Collaborator[];
  collaborator?: Collaborator;
  links!: string[];
  draft!: boolean;
  leader!: number;
  leaderInfo?: { firstName: string; lastName: string };
  partnerProgramsTags?: string[];
  partnerProgram!: PartnerProgramInfo | null;
  vacancies!: Vacancy[];
  isCompany!: boolean;
  inviteId!: number;

  static default(): Project {
    return {
      id: 0,
      name: "string",
      region: "sdf",
      targetAudience: "",
      implementationDeadline: "",
      actuality: "",
      trl: "",
      problem: "",
      description: "string",
      shortDescription: "string",
      achievements: [{ id: 3, title: "sdf", status: "dsaf" }],
      partners: [],
      resources: [],
      goals: [],
      industry: 0,
      viewsCount: 0,
      links: [],
      partnerProgram: null,
      cover: null,
      coverImageAddress: null,
      presentationAddress: "string",
      imageAddress: "string",
      numberOfCollaborators: 10,
      collaborators: [collaborator],
      draft: false,
      leader: 0,
      vacancies: [],
      isCompany: true,
      inviteId: 0,
    };
  }
}

export class ProjectCount {
  all!: number;
  my!: number;
  subs!: number;
  myLeader!: number;
  myInProgram!: number;
  mySubmitted!: number;
}

export type ProjectCountLoadState = "idle" | "loading" | "loaded" | "error";

export class ProjectStep {
  id!: number;
  name!: string;
}

const collaborator = {
  firstName: "string",
  lastName: "string",
  userId: 0,
  avatar: "string",
  skills: [
    {
      id: 309,
      name: "Python",
      category: {
        id: 7,
        name: "Back-end",
      },
    },
  ],
  role: "Front-end",
};
